export interface SystemState {   
    showLoading: boolean;
    messageResponse: MessageResponse | null;    
  }

export interface MessageResponse{
    code: number,
    message : string [],
    process?: string
}

export const TOGGLE_LOADING_INDICATOR = "TOGGLE_LOADING_INDICATOR";
export const SET_MESSAGE_RESPONSE = 'SET_MESSAGE_RESPONSE';

type AcceptedTypes =  typeof TOGGLE_LOADING_INDICATOR | typeof SET_MESSAGE_RESPONSE

interface UpdateSessionAction {
    type: AcceptedTypes;
    payload: SystemState | boolean| string | MessageResponse ;
}

export type SystemActionTypes = UpdateSessionAction ;
